// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand visual beside the Wix-onboarding account form. Self-contained (wav-*),
   brand purple (#5e1bff family), DM Sans. Fills its parent (.wxo-auth-visual). */
.wav {
  position: relative;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);
  color: #fff;
  font-family: 'DM Sans', system-ui, sans-serif;
}

/* faint diagonal grid that fades toward the bottom — premium depth, no banding */
.wav-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);
  pointer-events: none;
}
.wav-glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(58% 42% at 80% 8%, rgba(255, 255, 255, 0.17), transparent 62%);
  pointer-events: none;
}

.wav-inner {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 44px 40px;
  box-sizing: border-box;
}
/* Top block (header + carousel) is pinned to the top so the header never shifts
   when a carousel card's description wraps to an extra line; the marquee below it
   is pinned to the bottom of the panel. */
.wav-top {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.wav-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 14px;
}
.wav-title {
  font-size: 1.72rem;
  font-weight: 700;
  line-height: 1.16;
  letter-spacing: -0.015em;
  margin: 0 0 10px;
}
.wav-sub {
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.82);
  margin: 0 0 24px;
  max-width: 93%;
}

/* ── Carousel: ONE Wix action at a time, auto-advancing ── */
.wav-carousel { margin-top: 2px; }
.wav-action {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  padding: 17px 18px;
  backdrop-filter: blur(10px);
  box-shadow: 0 14px 32px rgba(18, 4, 52, 0.3);
  min-height: 116px;
  display: flex;
  flex-direction: column;
  animation: wav-action-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes wav-action-in {
  from { opacity: 0; transform: translateY(10px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
.wav-action-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 12px;
}
.wav-action-logo {
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);
}
/* Wix app logos are full-bleed colour tiles — let them fill, no white frame. */
.wav-action-logo img { width: 100%; height: 100%; object-fit: cover; display: block; }
.wav-action-app {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.66);
}
.wav-action-dot {
  margin-left: auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 0 4px rgba(52, 211, 153, 0.2);
}
.wav-action-title { font-size: 1.16rem; font-weight: 700; letter-spacing: -0.01em; }
.wav-action-desc {
  font-size: 0.84rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.78);
  margin-top: 4px;
}

/* prev / dots / next */
.wav-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}
.wav-arrow {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;
  font-size: 0.72rem;
  transition: background 0.2s, transform 0.2s;
}
.wav-arrow:hover { background: rgba(255, 255, 255, 0.18); transform: translateY(-1px); }
.wav-dots {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 auto;
}
.wav-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: background 0.2s, width 0.2s;
}
.wav-dot.wav-on {
  width: 18px;
  border-radius: 3px;
  background: #fff;
}

/* ── Marquee: everything the agent connects to (pinned to the bottom) ── */
.wav-more { flex: 0 0 auto; margin-top: 22px; }
.wav-more-label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}
.wav-marquee {
  margin-top: 12px;
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);
}
.wav-marquee-track {
  display: flex;
  width: max-content;
  animation: wav-marquee 26s linear infinite;
}
.wav-marquee:hover .wav-marquee-track { animation-play-state: paused; }
/* Each logo is wrapped in InfoTooltip — its .info-tooltip-wrapper is the flex item.
   Put the loop margin on the wrapper (not the tile) so the duplicated track still
   translates -50% seamlessly. */
.wav-marquee-track .info-tooltip-wrapper {
  flex: 0 0 auto;
  margin: 0 9px 0 0;
}
.wav-more-logo {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #fff;
  display: grid;
  place-items: center;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.14);
  cursor: default;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.wav-more-logo:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);
}
.wav-more-logo img { width: 21px; height: 21px; object-fit: contain; }
@keyframes wav-marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .wav-action { animation: none; }
  .wav-marquee-track { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/WixAuthVisual.css"],"names":[],"mappings":"AAAA;iFACiF;AACjF;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,WAAW;EACX,6CAA6C;AAC/C;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAE1B,0EAA0E;EAC1E,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;0CAE0C;AAC1C;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D,gBAAgB,eAAe,EAAE;AACjC;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAElB,2BAA2B;EAC3B,4CAA4C;EAC5C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gEAAgE;AAClE;AACA;EACE,OAAO,UAAU,EAAE,wCAAwC,EAAE;EAC7D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA,+EAA+E;AAC/E,uBAAuB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACrF;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;AACA,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACnF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA,mBAAmB,qCAAqC,EAAE,2BAA2B,EAAE;AACvF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAEhB,gFAAgF;AAClF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;AACA,wCAAwC,4BAA4B,EAAE;AACtE;;gCAEgC;AAChC;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,qBAAqB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACrE;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,cAAc,eAAe,EAAE;EAC/B,qBAAqB,eAAe,EAAE;AACxC","sourcesContent":["/* Brand visual beside the Wix-onboarding account form. Self-contained (wav-*),\r\n   brand purple (#5e1bff family), DM Sans. Fills its parent (.wxo-auth-visual). */\r\n.wav {\r\n  position: relative;\r\n  height: 100%;\r\n  min-height: 100%;\r\n  overflow: hidden;\r\n  background: linear-gradient(158deg, #6a28ff 0%, #4c18cc 52%, #2c0a63 100%);\r\n  color: #fff;\r\n  font-family: 'DM Sans', system-ui, sans-serif;\r\n}\r\n\r\n/* faint diagonal grid that fades toward the bottom — premium depth, no banding */\r\n.wav-grid {\r\n  position: absolute;\r\n  inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255, 255, 255, 0.06) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);\r\n  background-size: 34px 34px;\r\n  -webkit-mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);\r\n  mask-image: radial-gradient(125% 80% at 72% 0%, #000 35%, transparent 78%);\r\n  pointer-events: none;\r\n}\r\n.wav-glow {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: radial-gradient(58% 42% at 80% 8%, rgba(255, 255, 255, 0.17), transparent 62%);\r\n  pointer-events: none;\r\n}\r\n\r\n.wav-inner {\r\n  position: relative;\r\n  z-index: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 44px 40px;\r\n  box-sizing: border-box;\r\n}\r\n/* Top block (header + carousel) is pinned to the top so the header never shifts\r\n   when a carousel card's description wraps to an extra line; the marquee below it\r\n   is pinned to the bottom of the panel. */\r\n.wav-top {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.wav-eyebrow {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.16em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.72);\r\n  margin-bottom: 14px;\r\n}\r\n.wav-title {\r\n  font-size: 1.72rem;\r\n  font-weight: 700;\r\n  line-height: 1.16;\r\n  letter-spacing: -0.015em;\r\n  margin: 0 0 10px;\r\n}\r\n.wav-sub {\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n  color: rgba(255, 255, 255, 0.82);\r\n  margin: 0 0 24px;\r\n  max-width: 93%;\r\n}\r\n\r\n/* ── Carousel: ONE Wix action at a time, auto-advancing ── */\r\n.wav-carousel { margin-top: 2px; }\r\n.wav-action {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  border-radius: 16px;\r\n  padding: 17px 18px;\r\n  -webkit-backdrop-filter: blur(10px);\r\n  backdrop-filter: blur(10px);\r\n  box-shadow: 0 14px 32px rgba(18, 4, 52, 0.3);\r\n  min-height: 116px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: wav-action-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;\r\n}\r\n@keyframes wav-action-in {\r\n  from { opacity: 0; transform: translateY(10px) scale(0.985); }\r\n  to   { opacity: 1; transform: translateY(0) scale(1); }\r\n}\r\n.wav-action-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  margin-bottom: 12px;\r\n}\r\n.wav-action-logo {\r\n  flex: 0 0 auto;\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 11px;\r\n  overflow: hidden;\r\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);\r\n}\r\n/* Wix app logos are full-bleed colour tiles — let them fill, no white frame. */\r\n.wav-action-logo img { width: 100%; height: 100%; object-fit: cover; display: block; }\r\n.wav-action-app {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.66);\r\n}\r\n.wav-action-dot {\r\n  margin-left: auto;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #34d399;\r\n  box-shadow: 0 0 0 4px rgba(52, 211, 153, 0.2);\r\n}\r\n.wav-action-title { font-size: 1.16rem; font-weight: 700; letter-spacing: -0.01em; }\r\n.wav-action-desc {\r\n  font-size: 0.84rem;\r\n  line-height: 1.4;\r\n  color: rgba(255, 255, 255, 0.78);\r\n  margin-top: 4px;\r\n}\r\n\r\n/* prev / dots / next */\r\n.wav-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-top: 14px;\r\n}\r\n.wav-arrow {\r\n  flex: 0 0 auto;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgba(255, 255, 255, 0.22);\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 0.72rem;\r\n  transition: background 0.2s, transform 0.2s;\r\n}\r\n.wav-arrow:hover { background: rgba(255, 255, 255, 0.18); transform: translateY(-1px); }\r\n.wav-dots {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin: 0 auto;\r\n}\r\n.wav-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  padding: 0;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  cursor: pointer;\r\n  transition: background 0.2s, width 0.2s;\r\n}\r\n.wav-dot.wav-on {\r\n  width: 18px;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n}\r\n\r\n/* ── Marquee: everything the agent connects to (pinned to the bottom) ── */\r\n.wav-more { flex: 0 0 auto; margin-top: 22px; }\r\n.wav-more-label {\r\n  font-size: 10.5px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.1em;\r\n  text-transform: uppercase;\r\n  color: rgba(255, 255, 255, 0.6);\r\n}\r\n.wav-marquee {\r\n  margin-top: 12px;\r\n  overflow: hidden;\r\n  -webkit-mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\r\n  mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent);\r\n}\r\n.wav-marquee-track {\r\n  display: flex;\r\n  width: max-content;\r\n  animation: wav-marquee 26s linear infinite;\r\n}\r\n.wav-marquee:hover .wav-marquee-track { animation-play-state: paused; }\r\n/* Each logo is wrapped in InfoTooltip — its .info-tooltip-wrapper is the flex item.\r\n   Put the loop margin on the wrapper (not the tile) so the duplicated track still\r\n   translates -50% seamlessly. */\r\n.wav-marquee-track .info-tooltip-wrapper {\r\n  flex: 0 0 auto;\r\n  margin: 0 9px 0 0;\r\n}\r\n.wav-more-logo {\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 9px;\r\n  background: #fff;\r\n  display: grid;\r\n  place-items: center;\r\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.14);\r\n  cursor: default;\r\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\r\n}\r\n.wav-more-logo:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);\r\n}\r\n.wav-more-logo img { width: 21px; height: 21px; object-fit: contain; }\r\n@keyframes wav-marquee {\r\n  from { transform: translateX(0); }\r\n  to   { transform: translateX(-50%); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .wav-action { animation: none; }\r\n  .wav-marquee-track { animation: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
